module.exports = __webpack_public_path__ + "static/media/scenarios-brikk-preview.b1eba676.png";